import { ReactNode } from "react";
import { RoomProvider } from "../../../liveblocks.config";
import { ClientSideSuspense } from "@liveblocks/react";
import React from "react";
import { useCanvasId, useUserId } from "@/utils/utils";

interface Props {
  children: ReactNode;
}

const NON_CANVAS_ROOM_ID = "non-canvas-room";

export const LiveblocksRoomWrapper = React.memo(({ children }: Props) => {
  const canvasId = useCanvasId();

  const userId = useUserId();

  return (
    <RoomProvider
      id={canvasId ? `${canvasId}` : `${NON_CANVAS_ROOM_ID}-${userId}`}
      initialPresence={{ cursor: null }}
    >
      {children}
    </RoomProvider>
  );
});
